import { GraphQL } from "@rpi/openapi-api";
import { BadgeProps } from "@blurb/codex-react";

/** The subset of Badge colors the key statuses use; keeps the dot-color map exhaustive. */
export type KeyStatusBadgeColor = Extract<NonNullable<BadgeProps["color"]>, "green" | "gray">;

interface ApiKeyStatusDisplay {
  label: string;
  color: KeyStatusBadgeColor;
}

export const apiKeyStatusBadgeConfig: Record<GraphQL.ApiKeyStatus, ApiKeyStatusDisplay> = {
  [GraphQL.ApiKeyStatus.Enabled]: { label: "Enabled", color: "green" },
  [GraphQL.ApiKeyStatus.Disabled]: { label: "Disabled", color: "gray" },
};

export function nextStatus(current: GraphQL.ApiKeyStatus): GraphQL.ApiKeyStatus {
  return isEnabled(current) ? GraphQL.ApiKeyStatus.Disabled : GraphQL.ApiKeyStatus.Enabled;
}

export function isEnabled(status: GraphQL.ApiKeyStatus): boolean {
  return status === GraphQL.ApiKeyStatus.Enabled;
}
